module.exports = __webpack_public_path__ + "static/img/14010212.3414d67d.png";